/** Тип электронных торгов */
export enum EElectronicTradingType {
  /** Не показывать */
  DoNotDisplay = 2,
  /** Только торги и залоговая недвижимость */
  ElectronicTradingOnly = 1,
}
